import React, { createContext, ReactNode, useContext, useState } from "react";

interface LayoutContainerClass {
  containerClass: string;
  setContainerClass: (classNames: string) => void;
}

const LayoutContainerClassContext = createContext<LayoutContainerClass | undefined>(undefined);

interface LayoutContainerClassProviderProps {
  children: ReactNode;
}

export const LayoutContainerClassProvider = ({ children }: LayoutContainerClassProviderProps) => {
  const [containerClass, setContainerClass] = useState<string>("relative pb-16 bg-[#f0f5fb]");

  return (
    <LayoutContainerClassContext.Provider value={{ containerClass, setContainerClass }}>
      {children}
    </LayoutContainerClassContext.Provider>
  );
};

export const useContainerClass = (): LayoutContainerClass => {
  const context = useContext(LayoutContainerClassContext);
  if (!context) {
    throw new Error("useContainerClass must be used within a LayoutContainerClassProvider");
  }
  return context;
};
